import { Box, Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { MsgUserText } from '../../msg-parts';
import { useMsgMediaTitle } from './hooks';

export interface MsgMediaCallContentProps {
  message: Msg;
}

export const MsgMediaCallContent = memo(function MsgMediaCallContent({
  message,
}: MsgMediaCallContentProps) {
  const { t } = useTranslation();
  const { user_name, type } = message.payload;
  const { title } = useMsgMediaTitle({ type });

  return (
    <Box as="span" display="inline">
      <Text as="span" color="fg.error" display="inline">
        {title}
      </Text>
      <MsgUserText userName={user_name} display="inline" />
      <Text as="span" color="fg.muted" px="0.5" display="inline">
        {t('chat.onACall')}
      </Text>
    </Box>
  );
});
